import api from "./api";

export default class ReservationApi {
  static async Post(data) {
    return await api.post(`reservation`, data);
  }

  static async Change(data) {
    return await api.post(`reservation/change`, data);
  }
}
